export const checkHtmlTags = (tag, string) => {
  if (string) {
    const result = string.includes(tag);
    return result;
  }
  return false;
};
